<div class="container-textarea d-flex flex-column" [class.error]="error">
  <ng-content></ng-content>
</div>
